module.exports = __webpack_public_path__ + "img/gauge.00ff5da0.svg";